import { render, staticRenderFns } from "./PayDetail.vue?vue&type=template&id=bc6b6d02&scoped=true&"
import script from "./PayDetail.vue?vue&type=script&lang=js&"
export * from "./PayDetail.vue?vue&type=script&lang=js&"
import style0 from "./PayDetail.vue?vue&type=style&index=0&id=bc6b6d02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6b6d02",
  null
  
)

export default component.exports